import { useFormContext, useWatch } from 'react-hook-form'

import { Switch, SwitchProps } from '@/components/ui/switch'

interface SwitchFormFieldProps extends Omit<SwitchProps, 'checked' | 'onChange'> {
  name: string
}

export const SwitchFormField = ({ name, ...props }: SwitchFormFieldProps) => {
  const { setValue } = useFormContext()
  const checked = useWatch({ name }) ?? false

  return (
    <Switch
      {...props}
      checked={checked}
      onChange={(e) =>
        setValue(name, e.target.checked, {
          shouldDirty: true,
          shouldTouch: true,
          shouldValidate: true,
        })
      }
    />
  )
}
